/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-10-02 09:09:22
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Stack, Popover, InlineError } from '@shopify/polaris';
import validateColor from 'validate-color';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderColorPicker2 } from 'src/components/views/common/forms/render-color-picker-2';
import ColorWheel from 'src/assets/images/styles/colorWheel.png';

type Props = {
  swatch: boolean,
  item: Object,
  errorMessage: string
};

type ComposedProps = Props & WithI18nProps;

type State = {
  hexColor: Array<string>,
  activeColorPicker: Array<boolean>
};

class RenderColorCodesSelect extends Component<ComposedProps, State> {
  state = {
    hexColor: ['#FFFFFF', '#FFFFFF'],
    activeColorPicker: [false, false]
  };

  componentDidMount() {
    const { swatch } = this.props;
    const { colorCode01, colorCode02 } = swatch;

    // Calculate hex color
    this.setState({ hexColor: [colorCode01, colorCode02] });
  }

  componentWillReceiveProps(nextProps) {
    const { swatch } = nextProps;
    const { colorCode01, colorCode02 } = swatch;
    const { hexColor } = this.state;

    // Calculate hex color when change color from parent
    if (colorCode01 !== hexColor[0] || colorCode02 !== hexColor[1]) {
      this.setState({ hexColor: [colorCode01, colorCode02] });
    }
  }

  render() {
    const { i18n, item, swatch, errorMessage } = this.props;
    const { type } = swatch;
    const { activeColorPicker, hexColor } = this.state;

    // Build error message
    const { colorCode01: error1, colorCode02: error2 } = errorMessage;
    const error = !_.isEmpty(error1) ? error1 : !_.isEmpty(error2) ? error2 : undefined;

    const activator = position => (
      <div className="colorPickerBox">
        <div className="Polaris-TextField">
          <div
            className="Polaris-ResourceList__Badge selectedColor"
            style={
              hexColor[position]
                ? {
                    backgroundColor: hexColor[position]
                  }
                : {
                    background: `url("${ColorWheel}") center center / cover no-repeat`
                  }
            }
            onClick={e => this.handleOpenColorPicker(position)}></div>
          <input
            type="text"
            className="Polaris-TextField__Input"
            value={
              hexColor[position]
                ? hexColor[position].includes('#')
                  ? hexColor[position].toUpperCase()
                  : hexColor[position]
                : ''
            }
            placeholder={i18n.translate(
              'AdminHTML.SwatchSettings.SwatchSettings.swatchValue_Color_Placeholder'
            )}
            onClick={e => this.handleOpenColorPicker(position)}
            onChange={e => this.onInputColorValue(e, position)}
            onBlur={e => this.onBlurValue(e, position)}
          />
          <div className="Polaris-TextField__Backdrop"></div>
        </div>
      </div>
    );

    return (
      <div className="colorCode">
        <Stack>
          <Popover
            active={activeColorPicker[0]}
            activator={activator(0)}
            onClose={e => this.handleOpenColorPicker(0)}
            preferredAlignment="left">
            <Field
              name={`${item}.colorCode01`}
              component={RenderColorPicker2}
              color={hexColor[0]}
              onChange={color => this.handleChangeColor(color, 0)}
              normalize={color => (color.hex ? color.hex.toUpperCase() : '')}
            />
          </Popover>
          {type === 'twoColors' && (
            <Popover
              active={activeColorPicker[1]}
              activator={activator(1)}
              onClose={e => this.handleOpenColorPicker(1)}
              preferredAlignment="left">
              <Field
                name={`${item}.colorCode02`}
                component={RenderColorPicker2}
                color={hexColor[1]}
                onChange={color => this.handleChangeColor(color, 1)}
                normalize={color => (color.hex ? color.hex.toUpperCase() : '')}
              />
            </Popover>
          )}
        </Stack>
        {!_.isEmpty(error) && (
          <div>
            <InlineError message={error} />
          </div>
        )}
      </div>
    );
  }

  handleOpenColorPicker = position => {
    let { activeColorPicker } = this.state;
    activeColorPicker[position] = !activeColorPicker[position];

    this.setState({ activeColorPicker });
  };

  // Handle when change color on field
  handleChangeColor = (color, position) => {
    let { hexColor } = this.state;
    hexColor[position] = color.hex;

    this.setState({ hexColor });
  };

  // Handle when enter value
  onInputColorValue = (e, position) => {
    const hexColorItem = e.target.value;
    let { hexColor } = this.state;
    hexColor[position] = hexColorItem;

    // Convert hex to HSV color
    try {
      const { updateSwatchField, itemKey } = this.props;

      this.setState({ hexColor });

      // update color on redux-form
      updateSwatchField(itemKey, `colorCode0${position + 1}`, hexColorItem);

      return;
    } catch (error) {}

    this.setState({ hexColor });
  };

  // Validate after enter value
  onBlurValue = (e, position) => {
    let { hexColor } = this.state;
    const color = hexColor[position];

    if (!validateColor(color)) {
      const { updateSwatchField, itemKey } = this.props;

      hexColor[position] = '';

      this.setState({ hexColor });

      // update color on redux-form
      updateSwatchField(itemKey, `colorCode0${position + 1}`, color);
    }
  };
}

export default withI18n()(RenderColorCodesSelect);
